/** 優惠碼狀態 */
export enum PromoCodeStatusEnum {
  /** 0: 可使用 */
  ACTIVE,
  /** 1: 已使用 */
  USED,
  /** 2: 已過期 */
  EXPIRED,
  /** 3: 不可使用 */
  NOT_APPLICABLE,
  /** 4: 已額滿 */
  FULLY_USED,
}

/** 優惠碼按鈕狀態 */
export enum PromoCodeButtonStatus {
  /** 0: 可領取 */
  ACTIVE,
  /** 1: 已領取 */
  CLAIMED,
  /** 2: 已額滿 */
  FULLY_USED,
}

export enum EliteErrorCode {
  CreditCardNotEligible = 2900,
  CreditCardVerifyFail = 2901,
  CreditCardRepeatRedeemed = 2902,
}

export enum EliteErrorMessage {
  CreditCardNotEligible = 'credit_card_not_eligible_message',
  CreditCardVerifyFail = 'credit_card_verify_fail_message',
  CreditCardRepeatRedeemed = 'credit_card_repeat_redeemed_message',
}

/** 兌換 ELITE 會員 API 的 error code 和 error message(lokalise key) 對應 */
export const EliteErrorCodeMessageMap: Record<number | 'default', string> = {
  /** 2900: 卡號非 ELITE 合作名單 */
  [EliteErrorCode.CreditCardNotEligible]: EliteErrorMessage.CreditCardNotEligible,
  /** 2901: 卡號 KYC 驗證失敗 */
  [EliteErrorCode.CreditCardVerifyFail]: EliteErrorMessage.CreditCardVerifyFail,
  /** 2902: 卡號在此期間已兌換過 ELITE 會員 */
  [EliteErrorCode.CreditCardRepeatRedeemed]: EliteErrorMessage.CreditCardRepeatRedeemed,
  /** default: 卡號 KYC 驗證失敗 */
  default: EliteErrorMessage.CreditCardVerifyFail,
}

/** 兌換 ELITE 步驟 */
export enum EliteRedemptionStep {
  Redemption = 'redemption',
  Success = 'success',
}

export type VerifyPromoCodePayload = {
  promo_code: string
  bid?: number
}
export type GetMemberElitePayload = {
  region_id: number
}
export type RequestElitePayload = {
  prime: string
  cardholder: {
    name: string
    phone: string
    email: string
  }
  region_id: number
}
export type VerifyElitePayload = {
  rec_trade_id: string
}

/** 會員等級對應 */
export enum MembershipLevel {
  Seeker,
  Pro,
  Elite,
}

/** 性別對應 */
export enum Gender {
  UNSPECIFIED = -1,
  FEMALE,
  MALE,
  OTHER,
}

export const genderI18nKeyMap: Record<Gender, string> = {
  [Gender.FEMALE]: 'gender_select_female',
  [Gender.MALE]: 'gender_select_male',
  [Gender.OTHER]: 'gender_other',
  [Gender.UNSPECIFIED]: 'profile_not_provided',
}

export const MEMBER_PHONE_OTP_LENGTH = 4

/** 個資頁欄位 key（對應 member 欄位） */
export enum MemberForm {
  NICKNAME = 'nickname',
  GENDER = 'gender',
  BIRTHDAY = 'birthday',
  EMAIL = 'email',
}

export type MemberFormKey = MemberForm

export type MemberFormValue = Member[MemberFormKey] | null

/** 個資頁欄位輸入型態 */
export type MemberFormType = 'text' | 'select' | 'date'

/**
 * 個資頁單一欄位設定
 */
export type MemberFormItem = {
  key: MemberFormKey
  /** 欄位標題 */
  titleText: string
  /** 欄位型態 */
  type: MemberFormType
  /** 欄位編輯用元件 */
  component: Component
  /** 是否必填（未填顯示「待完成」badge） */
  isNeedComplete?: boolean
  /** 是否可編輯 */
  isEditable?: boolean
  /** 欄位下方提示文字 */
  note?: string
  /** 傳給欄位元件的專屬 props（例如 select 的 options、生日的 birthdayDefaultView） */
  componentProps?: Record<string, unknown>
  /** 依原始值算出欄位預設值；未提供則 fallback 為 value ?? '' */
  getDefaultValue?: (value: MemberFormValue) => MemberFormValue
}

export type Member = {
  account: string
  auth_type: number
  benefit: {
    achieve: string
    expired_at: string
    level: number
    level_name: string
    mile: number
    mile_expired_at: string
    next: {
      amount: number
      level: number
      level_name: string
      mile: number
      symbol_code: string
    }
  }
  bhd_editable: number
  birthday: string
  bonus: number
  bonus_valid_date: string
  company_name: string
  currency: number
  email: string
  enabled: number
  favorite_count: number
  fc_restore_id: string
  gender: number
  gift_expired_time: {
    timezone: string
    time: string
  }
  history: number
  invite_code: string
  is_elite: boolean
  is_profile_complete: boolean
  is_vip: boolean
  member_invite_cnt: number
  name: string | null
  nickname: string
  phone: string
  point: number
  promo_receivable: boolean
  promo_usable_cnt: number
  receipt_company: string
  region_id: number
  sum_past: number
  sum_this_month: number
  tax_id: string
  uid: number
  unexpired_gift_cnt: number
  unread_msg_cnt: number
  vip_end_time: string
  vip_start_time: string
}
